module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "center-title"
  }, [_vm._v(_vm._s(_vm.packageText)), _c('b-btn', {
    staticClass: "btn-minus",
    attrs: {
      "disabled": _vm.selectedIndex === _vm.packageCount
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.changePackage("down")
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  })]), _c('b-btn', {
    staticClass: "btn-plus",
    attrs: {
      "disabled": _vm.selectedIndex === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.changePackage("up")
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ddec24"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/package-slider/PackageSlider.vue
// module id = 947
// module chunks = 1